import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enCommon from '../locales/en/common.json';
import svCommon from '../locales/sv/common.json';
import noCommon from '../locales/no/common.json';
import daCommon from '../locales/da/common.json';
import fiCommon from '../locales/fi/common.json';
import enPortal from '../locales/en/portal.json';
import svPortal from '../locales/sv/portal.json';
import noPortal from '../locales/no/portal.json';
import daPortal from '../locales/da/portal.json';
import fiPortal from '../locales/fi/portal.json';

// i18next setup. English is the primary/fallback language; Swedish, Norwegian,
// Danish, and Finnish are all first-class. Locale files are bundled into the
// JS at build time (imported above) — no runtime fetch — so there's no CSP
// edge, no static-handler quirk, and TypeScript verifies the imports exist.
//
// Locale files live in src/locales/<lang>/<namespace>.json. CI fails the build
// if a key exists in en but is missing in any other supported locale
// (i18next-parser, see frontend/i18next-parser.config.cjs).

export const supportedLanguages = ['en', 'sv', 'no', 'da', 'fi'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const namespaces = ['common', 'portal'] as const;
export type Namespace = (typeof namespaces)[number];

export const i18n = i18next
  .createInstance()
  .use(LanguageDetector)
  .use(initReactI18next);

void i18n.init({
  fallbackLng: 'en',
  supportedLngs: [...supportedLanguages],
  ns: [...namespaces],
  defaultNS: 'common',
  resources: {
    en: { common: enCommon, portal: enPortal },
    sv: { common: svCommon, portal: svPortal },
    no: { common: noCommon, portal: noPortal },
    da: { common: daCommon, portal: daPortal },
    fi: { common: fiCommon, portal: fiPortal },
  },
  interpolation: {
    escapeValue: false, // React already escapes
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
});
